import '../css/GestionAdmin.css';
import React, { useEffect, useState } from "react";
import HeaderHomeAdmin from "../headers/headerHomeAdmin";
import { Button } from "react-bootstrap";
// import Card from "../components/card";
import { useHistory } from "react-router-dom";
import Footer from "../components/Footer";
import * as API from "../services/API";

function GestionAdmin(){
    const [adhesionNotif, setAdhesionNotif] = useState(0);
    const history = useHistory();
    useEffect(() => {
        API.getAdhesionNotifRequest(
          (response)=>{
            setAdhesionNotif(response.data);
          },
          ()=>{
          }
          )
        },
        []
    );

	return (
  <>
    <div className="min-vh-100 bg-light">
      <HeaderHomeAdmin />

      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold text-dark">
          Gestion
        </h2>

        <div className="row justify-content-center g-4">
          {/* Membres */}
          <div className="col-12 col-md-4">
            <div
              className="card h-100 shadow-sm border-0 text-center cursor-pointer"
              onClick={() => history.push("/admin/gestion/membres")}
            >
              <div className="card-body py-5">
                <div className="fs-1 mb-3">👥</div>
                <h5 className="fw-semibold">Membres</h5>
                <p className="text-muted mb-0">
                  Gestion des utilisateurs
                </p>
              </div>
            </div>
          </div>
           {/* Qui sommes-nous? */}
          <div className="col-12 col-md-4">
            <div
              className="card h-100 shadow-sm border-0 text-center cursor-pointer"
              onClick={() => history.push("/admin/gestion/qsn")}
            >
              <div className="card-body py-5">
                <div className="fs-1 mb-3">❓</div>
                <h5 className="fw-semibold">Qui sommes-nous?</h5>
                <p className="text-muted mb-0">
                  Paramétrage de Qui sommes-nous?
                </p>
              </div>
            </div>
          </div>

          {/* Galerie */}
          <div className="col-12 col-md-4">
            <div
              className="card h-100 shadow-sm border-0 text-center cursor-pointer"
              onClick={() => history.push("/admin/gestion/galerie")}
            >
              <div className="card-body py-5">
                <div className="fs-1 mb-3">🖼️</div>
                <h5 className="fw-semibold">Galerie</h5>
                <p className="text-muted mb-0">
                  Images et souvenirs
                </p>
              </div>
            </div>
          </div>

          {/* Évènements */}
          <div className="col-12 col-md-4">
            <div
              className="card h-100 shadow-sm border-0 text-center cursor-pointer"
              onClick={() => history.push("/admin/gestion/evenements")}
            >
              <div className="card-body py-5">
                <div className="fs-1 mb-3">📅</div>
                <h5 className="fw-semibold">Évènements</h5>
                <p className="text-muted mb-0">
                  Activités et planning
                </p>
              </div>
            </div>
          </div>
          {/* Contact */}
          <div className="col-12 col-md-4">
            <div
              className="card h-100 shadow-sm border-0 text-center cursor-pointer"
              onClick={() => history.push("/admin/gestion/contact")}
            >
              <div className="card-body py-5">
                <div className="fs-1 mb-3">📨</div>
                <h5 className="fw-semibold">Contact</h5>
                <p className="text-muted mb-0">
                  Paramétrage de contact
                </p>
              </div>
            </div>
          </div>
          {/* Partenaires */}
          <div className="col-12 col-md-4">
            <div
              className="card h-100 shadow-sm border-0 text-center cursor-pointer"
              onClick={() => history.push("/admin/gestion/partenaires")}
            >
              <div className="card-body py-5">
                <div className="fs-1 mb-3">🤝</div>
                <h5 className="fw-semibold">Partenaires</h5>
                <p className="text-muted mb-0">
                  Gestion des partenaires
                </p>
              </div>
            </div>
          </div>
           {/* Comptes rendu de CA */}
          <div className="col-12 col-md-4">
            <div
              className="card h-100 shadow-sm border-0 text-center cursor-pointer"
              onClick={() => history.push("/admin/gestion/espaceca")}
            >
              <div className="card-body py-5">
                <div className="fs-1 mb-3">📃</div>
                <h5 className="fw-semibold">Espace CA</h5>
                <p className="text-muted mb-0">
                  Gestion des comptes rendu de CA
                </p>
              </div>
            </div>
          </div>
          {/* Comptes rendu de CA */}
          <div className="col-12 col-md-4">
            <div
              className="card h-100 shadow-sm border-0 text-center cursor-pointer"
              onClick={() => history.push("/admin/file/link")}
            >
              <div className="card-body py-5">
                <div className="fs-1 mb-3">📃</div>
                <h5 className="fw-semibold">Génération de lien documentaire</h5>
                <p className="text-muted mb-0">
                  Génère des liens vers des documents (uniquement interne)
                </p>
              </div>
            </div>
          </div>
          {/* Demandes d'adhésion */}
          <div className="col-12 col-md-4">
            <div
              className="card h-100 shadow-sm border-0 text-center cursor-pointer position-relative"
              onClick={() => history.push("/admin/gestion/adhesion")}
            >
              {/* Badge de notification */}
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                style={{ zIndex: 1 }}
              >
                {adhesionNotif}
              </span>

              <div className="card-body py-5">
                <div className="fs-1 mb-3">📝</div>
                <h5 className="fw-semibold">Demandes d'adhésion</h5>
                <p className="text-muted mb-0">
                  Voir les nouvelles demandes
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </>
);
}


export default GestionAdmin;